import axios from 'axios'
import { baseApiUrl, uploaderUrl } from '../config'
import { showToast } from './toast'

function crudService (baseUrl) {
    const url = baseApiUrl + baseUrl
    const uploadUrl = uploaderUrl + baseUrl

    axios.defaults.headers.common['Authorization'] = localStorage.getItem('sr_token') || ''

    return {
        login: async function (payload) {
            const response = await axios.post(url, payload)
            showToast(response)
            return response.data.data
        },
        get: async function () {
            const { data } = await axios.get(url)
            return data.data
        },
        getWithQuery: async function(query) {
            const { data } = await axios.get(url, query)
            return data.data
        },
        getWithParams: async function (params) {
            const { data } = await axios.get(`${url}/${params}`)
            return data.data
        },
        create: async function (payload) {
            const response = await axios.post(url, payload)
            showToast(response)
        },
        createWithResult: async function (payload) {
            const { data } = await axios.post(url, payload)
            return data.data
        },
        update: async function (payload, params) {
            const response = await axios.put(`${url}/${params}`, payload)
            showToast(response)
            return response.data.data
        },
        delete: async function (params) {
            const response = await axios.delete(`${url}/${params}`)
            showToast(response)
        },
        upload: async function (payload) {
            const { data } = await axios.post(uploadUrl, payload)
            return data.data
        },
        removeAsset: async function (payload) {
            await axios.post(url, payload)
        },
        getReport(v) {
            return axios.post(`${url}/report`, v, {
              responseType: 'arraybuffer'
            });
        },
        getFileWithQuery: async function(query) {
            const { data } = await axios.get(url, {
                ...query,
                responseType: 'arraybuffer'
            })
            return data
        },
    }  
}

export default crudService